export const AUTH_USECASE_ERROR_MESSAGES = {
  // Auth User Usecases
  SIGN_IN_FAILED: 'Sign in failed. Please try again.',
  GOOGLE_SIGN_IN_FAILED: 'Google sign in failed. Please try again.',
  SIGN_UP_FAILED: 'Sign up failed. Please try again.',
  PASSWORD_CHANGE_FAILED: 'Failed to change password. Please try again.',
  SIGN_OUT_FAILED: 'Signout failed. Please try again.',

  // Auth Session usecases(verify & refresh token)
  SESSION_EXPIRED: 'Session expired. Please sign in again.',
} as const;
